import Cookie from 'js-cookie'
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_COOKIE_NAME,
  LANGUAGES,
} from 'localization/enums/LocalizationEnums'
import { getStandardLocaleCode } from 'localization/utils/locale-utils'

export const getLocaleDateTime = (utcDate: string, options?: Intl.DateTimeFormatOptions) => {
  const locale = Cookie.get(LANGUAGE_COOKIE_NAME) || DEFAULT_LANGUAGE
  const localeData = LANGUAGES?.[getStandardLocaleCode(locale)]
  const { dateTimeFormat, localeCode } = localeData

  const date = new Date(utcDate)

  return new Intl.DateTimeFormat(localeCode, {
    ...(options ? options : {}),
    ...dateTimeFormat,
  }).format(date)
}

export const getLocalDate = (utcDate: string, options?: Intl.DateTimeFormatOptions) => {
  const locale = Cookie.get(LANGUAGE_COOKIE_NAME) || DEFAULT_LANGUAGE
  const localeData = LANGUAGES?.[getStandardLocaleCode(locale)]
  const { dateFormat, localeCode } = localeData

  const date = new Date(utcDate)

  return new Intl.DateTimeFormat(localeCode, {
    ...options,
    ...dateFormat,
  }).format(date)
}
